import React, { useState } from 'react';
import LinkInvoiceQuoteButtons from '../../accounting/invoice/LinkInvoiceQuoteButtons';
import LinkExistingInvoiceQuoteModal from '../../accounting/invoice/LinkExistingInvoiceQuoteModal';

const LinkInvoiceQuoteFeature = ({ onLinkInvoice, onLinkQuote }) => {
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  return (
    <>
      <LinkInvoiceQuoteButtons
        onLinkInvoice={() => setShowInvoiceModal(true)}
        onLinkQuote={() => setShowQuoteModal(true)}
      />
      <LinkExistingInvoiceQuoteModal
        visible={showInvoiceModal}
        type="invoice"
        onSelect={(item) => {
          setShowInvoiceModal(false);
          onLinkInvoice(item);
        }}
        onCancel={() => setShowInvoiceModal(false)}
      />
      <LinkExistingInvoiceQuoteModal
        visible={showQuoteModal}
        type="quote"
        onSelect={(item) => {
          setShowQuoteModal(false);
          onLinkQuote(item);
        }}
        onCancel={() => setShowQuoteModal(false)}
      />
    </>
  );
};

export default LinkInvoiceQuoteFeature;
